function formatMoney(cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
}

function buildBlock(product) {
  const shopDataElement = document.getElementById("shop-data");
  const moneyFormat = shopDataElement.dataset.moneyFormat;
  const formattedPrice = formatMoney(product.price, moneyFormat);

  let actionButtonHtml;
  if (product.variants.length > 1) {
    actionButtonHtml = `
          <a href="${product.url}" class="button view-button">View</a>
        `;
  } else {
    actionButtonHtml = `
          <form class="add-to-cart-form" data-product-id="${product.variants[0].id}">
            <input name="id" type="hidden" value="${product.variants[0].id}" />
            <button type="submit"><i class="fa fa-plus" aria-hidden="true"></i> Add</button>
          </form>
        `;
  }

  const html = `
      <div class="related-product" href="${product.url}">
        <a href="${product.url}">
          <img src="${product.images[0]}" />
        </a>
        <a href="${product.url}">  
          <h6>${product.title}</h6>
        </a>
        <p class="text-body--small" style="font-weight:bold;">${formattedPrice} <span style="font-weight:normal">INC VAT</span></p>
        ${actionButtonHtml}
      </div>
    `;

  return html;
}

document.addEventListener("DOMContentLoaded", function() {
const cardIdInput = document.getElementById("card-id");
const cardId = cardIdInput ? cardIdInput.value : null;
console.log("Card ID:", cardId);

const notificationIdInput = document.getElementById("notification-product-id");
const notificationId = notificationIdInput ? notificationIdInput.value : null;
console.log("Notification ID:", notificationId);

const productIdInputs = document.querySelectorAll('input[name="product-id"]');
let productId = null;

console.log("Number of product-id inputs:", productIdInputs.length);

for (let i = 0; i < productIdInputs.length; i++) {
  const input = productIdInputs[i];
  console.log("Input value:", input.value);
  if (input.value !== null && input.value.trim() !== "") {
    productId = input.value;
    console.log("Product ID found:", productId);
    break;
  } else {
    console.log("Skipping empty or null value.");
  }
}

let relatedId =
  notificationId !== null
    ? notificationId
    : cardId !== null
    ? cardId
    : productId;
console.log("Final Related ID:", relatedId);

const complimentaryTitle = document.getElementById("complimentary-title").textContent.trim();

if (
  relatedId !== undefined &&
  relatedId !== null &&
  relatedId.trim() !== ""
) {
  const complimentaryProductsContainer = document.querySelector(
    ".complimentary-products_container"
  );

  fetch(
    window.Shopify.routes.root +
      "recommendations/products.json?product_id=" +
      relatedId +
      "&limit=4&intent=complementary"
  )
    .then((response) => {
      if (!response.ok) {
        throw new Error("Failed to fetch complementary products");
      }
      return response.json();
    })
    .then(({ products }) => {
      if (products.length === 0) {
        fetch(
          window.Shopify.routes.root +
            "recommendations/products.json?product_id=" +
            relatedId +
            "&limit=4&intent=related"
        )
          .then((response) => {
            if (!response.ok) {
              throw new Error("Failed to fetch related products");
            }
            return response.json();
          })
          .then(({ products }) => {
            products.forEach((product) => {
              const html = buildBlock(product);
              document.querySelector(".complimentary-products").innerHTML +=
                html;
            });

            // Add the translated title before the .complimentary-products_container div
            const titleHtml = `<h3>${complimentaryTitle}</h3>`;
            complimentaryProductsContainer.insertAdjacentHTML(
              "beforebegin",
              titleHtml
            );
          })
          .catch((error) => {
            console.error("Error fetching related products:", error);
          });
      } else {
        products.forEach((product) => {
          const html = buildBlock(product);
          document.querySelector(".complimentary-products").innerHTML += html;
        });

        // Add the translated title before the .complimentary-products_container div
        const titleHtml = `<h3>${complimentaryTitle}</h3>`;
        complimentaryProductsContainer.insertAdjacentHTML(
          "beforebegin",
          titleHtml
        );
      }
    })
    .catch((error) => {
      console.error("Error fetching complementary products:", error);
    });
}

document.addEventListener("submit", function (event) {
  if (event.target && event.target.classList.contains("add-to-cart-form")) {
    event.preventDefault();
    const form = event.target;
    const addButton = form.querySelector('button[type="submit"]');
    const productId = form.dataset.productId;

    addButton.textContent = 'Adding...';
    addButton.disabled = true;

    addToCart(productId, addButton);

    return false;
  }
});

function addToCart(productId, addButton) {
  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      id: productId,
      quantity: 1, // Always adding a quantity of 1
    }),
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error("Failed to add product to cart");
      }
      return response.json();
    })
    .then((data) => {
      console.log("Product added to cart:", data);
      addButton.textContent = 'Added';
      addButton.classList.add('disabled');
      addButton.disabled = true;

      // Call updateCartCount function to update cart count
      updateCartCount(data.quantity);
    })
    .catch((error) => {
      console.error("Error adding product to cart:", error);
    });
}

function updateCartCount(count) {
  const cartCountBubbles = document.querySelectorAll('#cart-icon-bubble .cart-count-bubble');
  console.log("Cart Count Bubbles:", cartCountBubbles);

  cartCountBubbles.forEach((cartCountBubble) => {
    console.log("Cart Count Bubble:", cartCountBubble);
    const cartCountSpan = cartCountBubble.querySelector('span[aria-hidden="true"]');
    console.log("Cart Count Span:", cartCountSpan);

    let visuallyHiddenText = cartCountBubble.querySelector('.visually-hidden');
    if (!visuallyHiddenText) {
      visuallyHiddenText = document.createElement('span');
      visuallyHiddenText.className = 'visually-hidden';
      cartCountBubble.appendChild(visuallyHiddenText);
    }
    console.log("Visually Hidden Text:", visuallyHiddenText);

    if (cartCountSpan && visuallyHiddenText) {
      const currentCount = parseInt(cartCountSpan.textContent || 0);
      const newCount = currentCount + count;

      if (newCount < 100) {
        // Update cart count
        cartCountSpan.textContent = newCount;
        visuallyHiddenText.textContent = `Cart count: ${newCount}`;
        visuallyHiddenText.setAttribute('aria-hidden', 'false');
      } else {
        // Hide cart count if it's greater than or equal to 100
        cartCountBubble.innerHTML = '';
        visuallyHiddenText.textContent = `Cart count: 100+`;
        visuallyHiddenText.setAttribute('aria-hidden', 'false');
      }
    } else {
      console.log("Cart count elements not found.");
    }
  });
}
  
});